const enquiryReplyTrackEvent = () => {};

const enquiryReplyAcceptTrackEvent = () => {};

const bookingGuaranteeBannerClicked = () => {};

const annotationClicked = () => {};

const annotationShown = () => {};

const bookingGuaranteePopupLinkClicked = () => {};

const inviteReplyAccepted = () => {};

const inviteReplyDeclined = () => {};

const systemMessageRequestToBookShown = () => {};

const systemMessageRequestToBookClick = () => {};

const seekerRequestedVisit = () => {};

const userProposedVisit = () => {};

const visitProposalOpened = () => {};

export const contactRequestShown = () => {};

export const contactRequestClick = () => {};

const distributionScreenChatClick = () => {};

const distributionScreenVisitClick = () => {};

const distributionScreenBookClick = () => {};

export const enquiryUserPictureClick = () => {};

export const enquiryProfileInfoClick = () => {};

export const damageCoverageActivated = () => {};

const conversationTrackingEvents = (data) => {
  const { seekerId, roomId, userRole, userId, connectionId } = data;
  return {
    enquiryReplyAccept: () =>
      enquiryReplyAcceptTrackEvent({ seekerId, roomId }),
    enquiryReply: () => enquiryReplyTrackEvent({ seekerId, roomId }),
    bookingGuaranteeBannerClicked: () =>
      bookingGuaranteeBannerClicked({ userRole }),
    annotationClicked: () => annotationClicked({ userRole }),
    annotationShown: () => annotationShown({ userRole }),
    bookingGuaranteePopupLinkClicked: () =>
      bookingGuaranteePopupLinkClicked({ userRole }),
    inviteReplyAccepted: () => inviteReplyAccepted({ seekerId, roomId }),
    inviteReplyDeclined: () => inviteReplyDeclined({ seekerId, roomId }),
    systemMessageRequestToBookShown: () =>
      systemMessageRequestToBookShown({ roomId, seekerId }),
    systemMessageRequestToBookClick: () =>
      systemMessageRequestToBookClick({ roomId, seekerId }),
    seekerRequestedVisit: () => seekerRequestedVisit({ roomId, seekerId }),
    userProposedVisit: ({ wasRequested }) =>
      userProposedVisit({ roomId, seekerId, wasRequested }),
    visitProposalOpened: () => visitProposalOpened({ roomId, seekerId }),
    distributionScreenChatClick: () =>
      distributionScreenChatClick({ userId, connectionId }),
    distributionScreenVisitClick: () =>
      distributionScreenVisitClick({ userId, connectionId }),
    distributionScreenBookClick: () =>
      distributionScreenBookClick({ userId, connectionId }),
    damageCoverageActivated: () => damageCoverageActivated({ userId, roomId }),
    data,
  };
};

export default conversationTrackingEvents;
